import { Injectable } from '@angular/core';
import { HttpService } from 'library-explorer';
import { Observable, of, switchMap } from 'rxjs';
import { ClassDTO } from '../../model/classDTO.model';
import { interceptorsToken } from 'library-explorer';
import { HttpParams } from '@angular/common/http';
import { DataResponse } from '@app/model/data-response.model';

@Injectable({
  providedIn: 'root'
})
export class ClassService {

  constructor(
    private httpService: HttpService
  ) { }

  public getClassByID(courseID: string): Observable<ClassDTO> {
    const params = new HttpParams()
      .set('active', 'true')
      .set('id', courseID)
      .set(interceptorsToken.HANDLE_PERMISSION_DENIED_PARAM, 'true');

    return this.httpService.get<ClassDTO>('node', params);
  }

  public getClasses(extraParams: HttpParams = null): Observable<DataResponse<ClassDTO>> {
    let params = extraParams || new HttpParams();
    params = params
      .set('active', 'true')
      .set(interceptorsToken.HANDLE_PERMISSION_DENIED_PARAM, 'true');

    return this.httpService.get<DataResponse<ClassDTO>>('classes', params);
  }
  
  public getAllClasses(
    extraParams: HttpParams = null,
    classes: ClassDTO[] = [],
    pagination: any = { itemsPerPage: 10, currentPage: 1, offset: 0 }
  ): Observable<ClassDTO[]> {
    let params = extraParams || new HttpParams();
    params = params
      .set('limit', pagination.itemsPerPage)
      .set('offset', pagination.offset);
    
    return this.getClasses(params).pipe(
      switchMap(res => {
        classes = [...classes, ...res.items];
        
        if (res._meta.maxcount <= classes.length) {
          return of(classes);
        }
        
        pagination.currentPage++;
        pagination.offset = (pagination.currentPage - 1) * pagination.itemsPerPage;
        return this.getAllClasses(params, classes, pagination);
      })
    );
  }


  public getSitemap(extraParams: HttpParams = null): Observable<DataResponse<ClassDTO>> {
    let params = extraParams || new HttpParams();
    params = params
      .set('active', 'true')
      .set('display', 'site-map');

    return this.httpService.get<DataResponse<ClassDTO>>('classes', params);
  }

  public getSitemapByEntityId(id: string): Observable<ClassDTO> {
    const params = new HttpParams({ fromObject: { active: true, display: 'site-map' } });

    return this.httpService.get<ClassDTO>(`content-info/${id}`, params);
  }
}
